import _toConsumableArray from "D:\\TeamCity\\buildAgent3\\work\\7af605790b8ebbcb\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import { Chart, registerables } from '../dist/chart.mjs';
Chart.register.apply(Chart, _toConsumableArray(registerables));
export default Chart;